export const RoundedCheckMarkIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.0004" cy="11.9999" r="9.6" fill="#50C878" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6 20.2C13.1461 20.2 15.5879 19.1886 17.3882 17.3882C19.1886 15.5879 20.2 13.1461 20.2 10.6C20.2 8.05392 19.1886 5.61212 17.3882 3.81178C15.5879 2.01143 13.1461 1 10.6 1C8.05392 1 5.61212 2.01143 3.81178 3.81178C2.01143 5.61212 1 8.05392 1 10.6C1 13.1461 2.01143 15.5879 3.81178 17.3882C5.61212 19.1886 8.05392 20.2 10.6 20.2ZM15.0484 9.0484C15.267 8.82208 15.3879 8.51896 15.3852 8.20432C15.3825 7.88968 15.2563 7.58871 15.0338 7.36622C14.8113 7.14373 14.5103 7.01753 14.1957 7.01479C13.881 7.01206 13.5779 7.13301 13.3516 7.3516L9.4 11.3032L7.8484 9.7516C7.62208 9.53301 7.31895 9.41206 7.00432 9.41479C6.68968 9.41753 6.38871 9.54373 6.16622 9.76622C5.94373 9.98871 5.81753 10.2897 5.81479 10.6043C5.81206 10.919 5.93301 11.2221 6.1516 11.4484L8.5516 13.8484C8.77663 14.0734 9.0818 14.1997 9.4 14.1997C9.7182 14.1997 10.0234 14.0734 10.2484 13.8484L15.0484 9.0484Z"
        fill="#D3D3D3"
      />
    </svg>
  );
};

export const CustomDropdownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none">
      <path
        d="M9.33017 6.5H14.6702C17.9902 6.5 19.3402 8.85 17.6902 11.72L16.9502 13C16.7702 13.31 16.4402 13.5 16.0802 13.5H7.92017C7.56017 13.5 7.23017 13.31 7.05017 13L6.31017 11.72C4.66017 8.85 6.01017 6.5 9.33017 6.5Z"
        fill="#292D32"
      />
      <path
        d="M8.78957 14.5H15.2196C15.6096 14.5 15.8496 14.92 15.6496 15.25L15.0096 16.35C13.3596 19.22 10.6396 19.22 8.98957 16.35L8.34957 15.25C8.15957 14.92 8.39957 14.5 8.78957 14.5Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const GreenDotsGroup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="none">
      <circle cx="19.3089" cy="2.30794" r="2.30794" fill="#50C878" />
      <circle cx="19.3089" cy="25.387" r="2.30794" fill="#50C878" />
      <circle cx="19.3089" cy="48.4666" r="2.30794" fill="#50C878" />
      <circle cx="19.3089" cy="71.5462" r="2.30794" fill="#50C878" />
      <circle cx="2.30794" cy="19.3079" r="2.30794" fill="#50C878" />
      <circle cx="2.30794" cy="42.387" r="2.30794" fill="#50C878" />
      <circle cx="2.30794" cy="65.4666" r="2.30794" fill="#50C878" />
      <circle cx="2.30794" cy="88.5462" r="2.30794" fill="#50C878" />
      <circle
        cx="41.9261"
        cy="71.5461"
        r="2.30794"
        transform="rotate(-90 41.9261 71.5461)"
        fill="#50C878"
      />
      <circle
        cx="65.0052"
        cy="71.5461"
        r="2.30794"
        transform="rotate(-90 65.0052 71.5461)"
        fill="#50C878"
      />
      <circle
        cx="88.0872"
        cy="71.5461"
        r="2.30794"
        transform="rotate(-90 88.0872 71.5461)"
        fill="#50C878"
      />
      <circle
        cx="24.9251"
        cy="88.5461"
        r="2.30794"
        transform="rotate(-90 24.9251 88.5461)"
        fill="#50C878"
      />
      <circle
        cx="48.0042"
        cy="88.5461"
        r="2.30794"
        transform="rotate(-90 48.0042 88.5461)"
        fill="#50C878"
      />
      <circle
        cx="71.0863"
        cy="88.5461"
        r="2.30794"
        transform="rotate(-90 71.0863 88.5461)"
        fill="#50C878"
      />
    </svg>
  );
};

export const BlueDotsGroup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="75"
      viewBox="0 0 28 75"
      fill="none">
      <circle cx="2.61067" cy="2.69856" r="2.30794" fill="#87CEEB" />
      <circle cx="2.61067" cy="25.7777" r="2.30794" fill="#87CEEB" />
      <circle cx="2.61067" cy="48.8573" r="2.30794" fill="#87CEEB" />
      <circle cx="2.61067" cy="71.9368" r="2.30794" fill="#87CEEB" />
      <circle cx="25.6917" cy="2.69856" r="2.30794" fill="#87CEEB" />
      <circle cx="25.6917" cy="25.7777" r="2.30794" fill="#87CEEB" />
      <circle cx="25.6917" cy="48.8573" r="2.30794" fill="#87CEEB" />
      <circle cx="25.6917" cy="71.9368" r="2.30794" fill="#87CEEB" />
    </svg>
  );
};

export const OutlineLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="201"
      height="151"
      viewBox="0 0 201 151"
      fill="none">
      <path
        d="M33.831 110.278C33.5845 106.537 33.3818 102.788 33.2226 99.0305C35.2652 98.4965 37.3163 97.9856 39.3761 97.4978L39.5141 97.4652L39.553 97.3288C48.4319 66.2146 63.3029 35.2818 84.0912 6.20684C91.5911 7.22267 99.002 8.47479 106.324 9.9632C84.9323 36.2762 68.7585 64.5928 57.9886 93.483L57.8439 93.8711L58.253 93.8066C59.8821 93.5497 62.738 93.3076 65.6094 93.0804C66.0859 93.0427 66.5626 93.0054 67.0341 92.9685C69.3965 92.7837 71.6249 92.6095 73.0021 92.446L73.1406 92.4296L73.1958 92.3015C83.8984 67.4787 95.5459 44.9096 114.406 22.3565C121.339 24.1845 128.151 26.2216 134.841 28.4679C116.072 48.356 103.884 68.2487 92.0772 90.5301L91.8797 90.9028L92.3011 90.8851C121.129 89.6768 145.276 93.3518 173.047 101.898C171.048 105.13 169.088 108.378 167.166 111.645C123.79 98.8083 77.4793 98.334 33.831 110.278Z"
        stroke="#000080"
        stroke-width="0.483957"
      />
      <path
        d="M100.007 116.473C132.593 116.736 164.734 123.761 194.237 137.066C191.516 139.891 188.848 142.746 186.231 145.632C157.969 133.415 127.296 127.22 96.3124 127.47C65.3775 127.72 34.864 134.39 6.85505 147.023C6.25985 143.234 5.73519 139.428 5.28104 135.607C35.0535 122.737 67.3665 116.21 100.007 116.473Z"
        stroke="#000080"
        stroke-width="0.483957"
      />
    </svg>
  );
};

export const WalletIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none">
      <path
        d="M6.66634 20.5842C3.71967 20.5842 1.33301 22.9709 1.33301 25.9176C1.33301 26.9176 1.61301 27.8642 2.10634 28.6642C3.02634 30.2109 4.71967 31.2509 6.66634 31.2509C8.61301 31.2509 10.3063 30.2109 11.2263 28.6642C11.7197 27.8642 11.9997 26.9176 11.9997 25.9176C11.9997 22.9709 9.61301 20.5842 6.66634 20.5842ZM9.29301 25.4776L6.45301 28.1042C6.26634 28.2776 6.01301 28.3709 5.77301 28.3709C5.51967 28.3709 5.26634 28.2776 5.06634 28.0776L3.74634 26.7576C3.35967 26.3709 3.35967 25.7309 3.74634 25.3442C4.13301 24.9576 4.77301 24.9576 5.15967 25.3442L5.79967 25.9842L7.93301 24.0109C8.33301 23.6376 8.97301 23.6642 9.34634 24.0642C9.71968 24.4642 9.69301 25.1042 9.29301 25.4776Z"
        fill="white"
      />
      <path
        d="M28.667 17.251H25.3337C23.867 17.251 22.667 18.451 22.667 19.9176C22.667 21.3843 23.867 22.5843 25.3337 22.5843H28.667C29.0403 22.5843 29.3337 22.291 29.3337 21.9176V17.9176C29.3337 17.5443 29.0403 17.251 28.667 17.251Z"
        fill="white"
      />
      <path
        d="M22.0396 7.78411C22.4396 8.17078 22.1063 8.77078 21.5463 8.77078L10.5063 8.75744C9.86629 8.75744 9.54629 7.98411 9.99962 7.53078L12.333 5.18411C14.3063 3.22411 17.493 3.22411 19.4663 5.18411L21.9863 7.73078C21.9996 7.74411 22.0263 7.77078 22.0396 7.78411Z"
        fill="white"
      />
      <path
        d="M29.1601 25.4641C28.3468 28.2108 26.0001 29.9175 22.8001 29.9175H14.1335C13.6135 29.9175 13.2801 29.3441 13.4935 28.8641C13.8935 27.9308 14.1468 26.8775 14.1468 25.9175C14.1468 21.8775 10.8535 18.5841 6.81348 18.5841C5.80014 18.5841 4.81348 18.7975 3.90681 19.1975C3.41348 19.4108 2.81348 19.0775 2.81348 18.5441V16.5841C2.81348 12.9575 5.00014 10.4241 8.40014 9.99748C8.73348 9.94415 9.09348 9.91748 9.46681 9.91748H22.8001C23.1468 9.91748 23.4801 9.93081 23.8001 9.98415C26.4935 10.2908 28.4401 11.9308 29.1601 14.3708C29.2935 14.8108 28.9735 15.2508 28.5201 15.2508H25.4668C22.5735 15.2508 20.2801 17.8908 20.9068 20.8908C21.3468 23.0775 23.3735 24.5841 25.6001 24.5841H28.5201C28.9868 24.5841 29.2935 25.0375 29.1601 25.4641Z"
        fill="white"
      />
    </svg>
  );
};

export const ArchiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none">
      <path
        d="M19.9071 3.50138V11.368C19.9071 11.9547 19.2138 12.248 18.7871 11.8614L16.4538 9.71472C16.2004 9.47472 15.8004 9.47472 15.5471 9.71472L13.2138 11.8481C12.7871 12.248 12.0938 11.9414 12.0938 11.368V3.50138C12.0938 3.12805 12.3871 2.83472 12.7604 2.83472H19.2404C19.6138 2.83472 19.9071 3.12805 19.9071 3.50138Z"
        fill="white"
      />
      <path
        d="M22.64 2.91457C22.2533 2.86123 21.9067 3.19457 21.9067 3.58123V11.6079C21.9067 12.6212 21.3067 13.5412 20.3733 13.9546C19.44 14.3546 18.36 14.1812 17.6133 13.4879L16.4533 12.4212C16.2 12.1812 15.8133 12.1812 15.5467 12.4212L14.3867 13.4879C13.9067 13.9412 13.28 14.1679 12.6533 14.1679C12.3067 14.1679 11.96 14.1012 11.6267 13.9546C10.6933 13.5412 10.0933 12.6212 10.0933 11.6079V3.58123C10.0933 3.19457 9.74667 2.86123 9.36 2.91457C5.62667 3.38123 4 5.90123 4 9.50123V22.8346C4 26.8346 6 29.5012 10.6667 29.5012H21.3333C26 29.5012 28 26.8346 28 22.8346V9.50123C28 5.90123 26.3733 3.38123 22.64 2.91457ZM23.3333 25.1679H12C11.4533 25.1679 11 24.7146 11 24.1679C11 23.6212 11.4533 23.1679 12 23.1679H23.3333C23.88 23.1679 24.3333 23.6212 24.3333 24.1679C24.3333 24.7146 23.88 25.1679 23.3333 25.1679ZM23.3333 19.8346H17.6667C17.12 19.8346 16.6667 19.3812 16.6667 18.8346C16.6667 18.2879 17.12 17.8346 17.6667 17.8346H23.3333C23.88 17.8346 24.3333 18.2879 24.3333 18.8346C24.3333 19.3812 23.88 19.8346 23.3333 19.8346Z"
        fill="white"
      />
    </svg>
  );
};

export const DocumentFilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none">
      <path
        d="M4.30699 1.91748H15.147C16.0537 1.91748 16.787 2.66415 16.787 3.58415V5.41081C16.787 6.07748 16.3737 6.90415 15.9603 7.31748L12.4403 10.4908C11.947 10.9041 11.627 11.7308 11.627 12.3975V15.9708C11.627 16.4641 11.2937 17.1308 10.8937 17.3841L9.73366 18.1441C8.66699 18.8108 7.18699 18.0641 7.18699 16.7308V12.3175C7.18699 11.7308 6.85366 10.9841 6.53366 10.5708L3.41366 7.23748C3.00033 6.82415 2.66699 6.07748 2.66699 5.58415V3.66415C2.66699 2.66415 3.40033 1.91748 4.30699 1.91748Z"
        fill="white"
      />
      <path
        d="M22.667 3.25098H19.467C19.0937 3.25098 18.8003 3.54431 18.8003 3.91764C18.8003 4.55764 18.8003 5.41098 18.8003 5.41098C18.8003 6.73098 18.0937 8.02431 17.4003 8.73098L13.7737 11.971C13.7337 12.0643 13.667 12.1976 13.627 12.3043V15.971C13.627 17.1843 12.907 18.5043 11.9203 19.1043L10.827 19.811C10.2137 20.1976 9.53366 20.3843 8.85366 20.3843C8.24033 20.3843 7.62699 20.2243 7.06699 19.9176C6.33277 19.511 5.78994 18.8843 5.47903 18.1509C5.36719 17.8871 5.33366 17.5988 5.33366 17.3123V14.1976C5.33366 14.0243 5.26699 13.851 5.13366 13.731L3.80033 12.3976C3.38699 11.971 2.66699 12.2643 2.66699 12.8643V23.251C2.66699 26.931 5.65366 29.9176 9.33366 29.9176H22.667C26.347 29.9176 29.3337 26.931 29.3337 23.251V9.91764C29.3337 6.23764 26.347 3.25098 22.667 3.25098ZM24.0003 24.251H14.667C14.1203 24.251 13.667 23.7976 13.667 23.251C13.667 22.7043 14.1203 22.251 14.667 22.251H24.0003C24.547 22.251 25.0003 22.7043 25.0003 23.251C25.0003 23.7976 24.547 24.251 24.0003 24.251ZM24.0003 18.9176H17.3337C16.787 18.9176 16.3337 18.4643 16.3337 17.9176C16.3337 17.371 16.787 16.9176 17.3337 16.9176H24.0003C24.547 16.9176 25.0003 17.371 25.0003 17.9176C25.0003 18.4643 24.547 18.9176 24.0003 18.9176Z"
        fill="white"
      />
    </svg>
  );
};

export const CommandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none">
      <path
        d="M21.587 3.25098H10.4137C5.56033 3.25098 2.66699 6.14431 2.66699 10.9976V22.1576C2.66699 27.0243 5.56033 29.9176 10.4137 29.9176H21.5737C26.427 29.9176 29.3203 27.0243 29.3203 22.171V10.9976C29.3337 6.14431 26.4403 3.25098 21.587 3.25098ZM12.8003 22.1843C12.8003 23.5043 11.7203 24.5843 10.4003 24.5843C9.08033 24.5843 8.00033 23.5043 8.00033 22.1843C8.00033 20.8643 9.08033 19.7843 10.4003 19.7843H11.467C12.2003 19.7843 12.8003 20.3843 12.8003 21.1176V22.1843ZM12.8003 12.051C12.8003 12.7843 12.2003 13.3843 11.467 13.3843H10.4003C9.08033 13.3843 8.00033 12.3043 8.00033 10.9843C8.00033 9.66431 9.08033 8.58431 10.4003 8.58431C11.7203 8.58431 12.8003 9.66431 12.8003 10.9843V12.051ZM18.867 18.251C18.867 18.9043 18.3337 19.451 17.667 19.451H14.3203C13.667 19.451 13.1203 18.9176 13.1203 18.251V14.9043C13.1203 14.251 13.6537 13.7043 14.3203 13.7043H17.667C18.3203 13.7043 18.867 14.2376 18.867 14.9043V18.251ZM21.6003 24.5843C20.2803 24.5843 19.2003 23.5043 19.2003 22.1843V21.1176C19.2003 20.3843 19.8003 19.7843 20.5337 19.7843H21.6003C22.9203 19.7843 24.0003 20.8643 24.0003 22.1843C24.0003 23.5043 22.9203 24.5843 21.6003 24.5843ZM21.6003 13.3843H20.5337C19.8003 13.3843 19.2003 12.7843 19.2003 12.051V10.9843C19.2003 9.66431 20.2803 8.58431 21.6003 8.58431C22.9203 8.58431 24.0003 9.66431 24.0003 10.9843C24.0003 12.3043 22.9203 13.3843 21.6003 13.3843Z"
        fill="white"
      />
    </svg>
  );
};
export const Ellipses = () => {
  return (
    <svg
      width="96"
      height="25"
      viewBox="0 0 96 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12.5842" r="12" fill="#50C878" />
      <circle cx="38" cy="12.5842" r="10" fill="#50C878" />
      <circle cx="60" cy="12.5842" r="8" fill="#50C878" />
      <circle cx="78" cy="12.5842" r="6" fill="#50C878" />
      <circle cx="92" cy="12.5842" r="4" fill="#50C878" />
    </svg>
  );
};

export const LeadLiftLogoIllustration = () => {
  return (
    <div className="w-[75px] h-[56px] md:w-[180px] md:h-[135px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 181 135"
        fill="none">
        <g style={{ mixBlendMode: "overlay" }}>
          <path
            d="M30.4064 98.1444C30.185 94.8035 30.0027 91.4554 29.8594 88.1001C31.6993 87.6225 33.5469 87.1657 35.4022 86.7294L35.5402 86.697L35.5794 86.5607C43.6026 58.6425 57.0399 30.8868 75.8239 4.79722C82.5841 5.70672 89.2644 6.82715 95.8647 8.15851C76.5412 31.7674 61.9298 57.1726 52.1988 83.0927L52.053 83.4809L52.4627 83.4168C53.9342 83.1864 56.5146 82.9692 59.1103 82.7652C59.5406 82.7314 59.9714 82.6979 60.3974 82.6649C62.5327 82.499 64.5477 82.3426 65.7931 82.1958L65.9313 82.1795L65.9867 82.0519C75.6581 59.7784 86.1827 39.5282 103.222 19.2929C109.471 20.9292 115.61 22.7521 121.64 24.7617C104.69 42.604 93.6777 60.4515 83.0116 80.4393L82.8124 80.8126L83.2351 80.795C109.278 79.711 131.094 83.0059 156.18 90.6693C154.383 93.555 152.62 96.4564 150.891 99.3736C111.695 87.8588 69.849 87.4323 30.4064 98.1444Z"
            stroke="#000080"
            stroke-width="0.483957"
          />
          <path
            d="M90.1992 103.761C119.637 103.997 148.674 110.296 175.329 122.227C172.882 124.75 170.482 127.3 168.128 129.877C142.584 118.916 114.862 113.357 86.8598 113.581C58.9059 113.806 31.3325 119.788 6.02086 131.12C5.48595 127.736 5.01415 124.337 4.60547 120.924C31.5082 109.38 60.7057 103.525 90.1992 103.761Z"
            stroke="#000080"
            stroke-width="0.483957"
          />
        </g>
      </svg>
    </div>
  );
};

export const SignedUpSuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="101"
      viewBox="0 0 100 101"
      fill="none">
      <path
        d="M75.0002 54.6667C71.0835 54.6667 67.4585 56.0418 64.5835 58.3334C60.7502 61.3751 58.3335 66.0834 58.3335 71.3334C58.3335 74.4584 59.2084 77.4167 60.7501 79.9167C63.6251 84.7501 68.9168 88.0001 75.0002 88.0001C79.2085 88.0001 83.0418 86.4584 85.9585 83.8334C87.2502 82.7501 88.3752 81.4167 89.2502 79.9167C90.7919 77.4167 91.6668 74.4584 91.6668 71.3334C91.6668 62.1251 84.2085 54.6667 75.0002 54.6667ZM83.6252 69.5418L74.7502 77.75C74.1668 78.2917 73.3751 78.5834 72.6251 78.5834C71.8335 78.5834 71.0418 78.2918 70.4168 77.6668L66.2918 73.5419C65.0835 72.3335 65.0835 70.3333 66.2918 69.125C67.5002 67.9166 69.5002 67.9166 70.7085 69.125L72.7085 71.1251L79.3751 64.9583C80.6251 63.7916 82.6251 63.8751 83.7918 65.1251C84.9584 66.3751 84.8752 68.3334 83.6252 69.5418Z"
        fill="#50CE78"
      />
      <path
        opacity="0.4"
        d="M87.875 90.0833C87.875 91.2499 86.9583 92.1666 85.7916 92.1666H14.2083C13.0417 92.1666 12.125 91.2499 12.125 90.0833C12.125 72.8333 29.125 58.8333 50 58.8333C54.2916 58.8333 58.4584 59.4165 62.2917 60.5415C59.8334 63.4581 58.3333 67.2499 58.3333 71.3333C58.3333 74.4583 59.2083 77.4166 60.7499 79.9166C61.5833 81.3332 62.6666 82.6248 63.9166 83.7081C66.8333 86.3748 70.7083 87.9999 75 87.9999C79.6666 87.9999 83.875 86.0832 86.875 82.9999C87.5417 85.2499 87.875 87.6249 87.875 90.0833Z"
        fill="#50CE78"
      />
      <path
        d="M49.9998 50.4999C61.5058 50.4999 70.8332 41.1725 70.8332 29.6666C70.8332 18.1607 61.5058 8.83325 49.9998 8.83325C38.4939 8.83325 29.1665 18.1607 29.1665 29.6666C29.1665 41.1725 38.4939 50.4999 49.9998 50.4999Z"
        fill="#50CE78"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none">
      <rect width="40" height="40" fill="white" />
      <path
        d="M29.4277 29.428L10.5715 10.5718"
        stroke="#494949"
        stroke-linecap="round"
      />
      <path
        d="M29.4285 10.5718L10.5723 29.428"
        stroke="#494949"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const CallBookingSuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="101"
      viewBox="0 0 100 101"
      fill="none">
      <path
        d="M70.8337 36.8333C70.042 36.8333 69.2503 36.5417 68.6253 35.9167L60.292 27.5833C59.0837 26.375 59.0837 24.375 60.292 23.1667C61.5003 21.9583 63.5003 21.9583 64.7087 23.1667L70.8337 29.2917L85.292 14.875C86.5003 13.6667 88.5003 13.6667 89.7087 14.875C90.917 16.0833 90.917 18.0833 89.7087 19.2917L73.042 35.9583C72.417 36.5 71.6253 36.8333 70.8337 36.8333Z"
        fill="#292D32"
      />
      <path
        opacity="0.4"
        d="M49.1247 59.7085L35.4997 73.3335C33.9997 72.0002 32.5413 70.6252 31.1247 69.2085C26.833 64.8752 22.958 60.3335 19.4997 55.5835C16.083 50.8335 13.333 46.0835 11.333 41.3752C9.33301 36.6252 8.33301 32.0835 8.33301 27.7502C8.33301 24.9168 8.83301 22.2085 9.83301 19.7085C10.833 17.1668 12.4163 14.8335 14.6247 12.7502C17.2913 10.1252 20.208 8.8335 23.2913 8.8335C24.458 8.8335 25.6247 9.0835 26.6663 9.5835C27.7497 10.0835 28.708 10.8335 29.458 11.9168L39.1247 25.5418C39.8747 26.5835 40.4163 27.5418 40.7913 28.4585C41.1663 29.3335 41.3747 30.2085 41.3747 31.0002C41.3747 32.0002 41.083 33.0002 40.4997 33.9585C39.958 34.9168 39.1663 35.9168 38.1663 36.9168L34.9997 40.2085C34.5413 40.6668 34.333 41.2085 34.333 41.8752C34.333 42.2085 34.3747 42.5002 34.458 42.8335C34.583 43.1668 34.708 43.4168 34.7913 43.6668C35.5413 45.0418 36.833 46.8335 38.6663 49.0002C40.5413 51.1668 42.5413 53.3752 44.708 55.5835C46.208 57.0418 47.6663 58.4585 49.1247 59.7085Z"
        fill="#50CE78"
      />
      <path
        d="M91.5417 76.875C91.5417 78.0417 91.3333 79.25 90.9167 80.4167C90.7917 80.75 90.6667 81.0833 90.5 81.4167C89.7917 82.9167 88.875 84.3333 87.6667 85.6667C85.625 87.9167 83.375 89.5417 80.8333 90.5833C80.7917 90.5833 80.75 90.625 80.7083 90.625C78.25 91.625 75.5833 92.1667 72.7083 92.1667C68.4583 92.1667 63.9167 91.1667 59.125 89.125C54.3333 87.0833 49.5417 84.3333 44.7917 80.875C43.1667 79.6667 41.5417 78.4583 40 77.1667L53.625 63.5417C54.7917 64.4167 55.8333 65.0833 56.7083 65.5417C56.9167 65.625 57.1667 65.75 57.4583 65.875C57.7917 66 58.125 66.0417 58.5 66.0417C59.2083 66.0417 59.75 65.7917 60.2083 65.3333L63.375 62.2083C64.4167 61.1667 65.4167 60.375 66.375 59.875C67.3333 59.2917 68.2917 59 69.3333 59C70.125 59 70.9583 59.1667 71.875 59.5417C72.7917 59.9167 73.75 60.4583 74.7917 61.1667L88.5833 70.9583C89.6667 71.7083 90.4167 72.5833 90.875 73.625C91.2917 74.6667 91.5417 75.7083 91.5417 76.875Z"
        fill="#50CE78"
      />
    </svg>
  );
};
